import CustomerLayout from "@/components/customer/CustomerLayout";
import MessagesView from "@/components/messaging/MessagesView";

export default function CustomerMessagesPage() {
  return (
    <CustomerLayout testid="customer-messages-page">
      <MessagesView role="customer" />
    </CustomerLayout>
  );
}
